import React, {useEffect, useMemo} from 'react';
import { EuiAvatar, EuiButtonEmpty, EuiFlexGroup, EuiFlexItem, EuiLink } from "@elastic/eui"

export const ListadoDnsScreen = (props:any) =>{
    
    const {data, onClickDn,dnSel, permissions} = props;

   useEffect(()=>{
        if(data.length>0){
            if(permissions.length>0)
            {
                const pos = data.findIndex((p: any) => p.idDN === permissions[0].idDN);
                onClickDn(data[pos])
            }else{
                data.length === 1 ? onClickDn(data[0]) : onClickDn(undefined)
            }
        } 
   },[permissions,data])

    

    const getPermissionArea = (idDn:string):string =>{
        const permission = permissions.filter((f:any)=> f.idDN===idDn);
        return permission.length>0 ? (permission.filter((f:any)=>f.codArea!=='').length>0 ? '#83d6b6' : '#ee789d') : '#ee789d'
    }

    const getPermissionDn = (idDn:string):string =>{
        const permission = permissions.filter((f:any)=> f.idDN===idDn);
        return permission.length>0 ? (permission.filter((f:any)=>f.codArea==='').length>0 ? '#83d6b6' : '#ee789d') : '#ee789d'
    }

    const getItems = () =>{
        return data && data.map((d:any)=>{
            return (<EuiFlexItem grow={false}>
                            <EuiLink
                            className={`btn-list-dn-permission ${d.idDN===dnSel?'active':''}`}
                            onClick={() => {onClickDn(d)}}
                            >
                            <EuiFlexGroup justifyContent='spaceAround' alignItems='center' gutterSize='s'>
                                <EuiFlexItem>{`${d.idDN} - ${d.direccionNegocio}`}</EuiFlexItem>
                                <EuiFlexItem grow={false}><EuiAvatar name="DireccionNegocio" initials="DN" initialsLength={2} color={getPermissionDn(d.idDN)} size='s'/></EuiFlexItem>
                                <EuiFlexItem grow={false}><EuiAvatar name="Area" initials="AR" initialsLength={2} color={getPermissionArea(d.idDN)} size='s'/></EuiFlexItem>
                            </EuiFlexGroup>
                            </EuiLink>
            </EuiFlexItem>)
        })
    }

    return (
        <EuiFlexGroup direction='column' style={{height:'100%',overflow:'auto'}} gutterSize='s'>
            {getItems()}
        </EuiFlexGroup>
    )
}